export default "__VITE_ASSET__a7c71ab9__"